import {
  LEGACY_SW_CACHE_NAMES,
  SW_CACHE_PREFIX,
} from '@/constants/appIdentity'
import '@/utils/migrateLegacyStorage'

async function cleanupLegacyCaches() {
  if (!('caches' in window)) return
  try {
    const keys = await caches.keys()
    await Promise.all(
      keys
        .filter(
          (name) =>
            LEGACY_SW_CACHE_NAMES.includes(name) ||
            (name.startsWith(SW_CACHE_PREFIX) && !name.endsWith('v1'))
        )
        .map((name) => caches.delete(name))
    )
  } catch (e) {
    // ignore
  }
}

export function registerServiceWorker() {
  cleanupLegacyCaches()

  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return
  }

  window.addEventListener('load', () => {
    const base = String(process.env.BASE_URL || '/').replace(/\/?$/, '/')
    const swUrl = `${base}sw.js`

    navigator.serviceWorker
      .register(swUrl, { scope: base })
      .catch((error) => {
        console.warn('Service Worker注册失败:', error)
      })
  })
}
